<div *ngIf="isLoadingResults" class="row">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  <div class="loading">
    <mat-spinner></mat-spinner>
  </div>
</div>

<!-- <a class="vida-sidenav-button" [routerLink]="['/search']" mat-button><mat-icon>arrow_back</mat-icon>Zurück
  zur Suche</a> -->
<div *ngIf="!isLoadingResults">

  <div id="copy-content" class="document-wrapper">

    <ng-container #printContainer>

      <div class="container-fluid heading document-header">
        <!-- <div id="header">
    </div> -->

        <!-- afterviewinit? output ? -->
        <div
          class="d-flex justify-content-between navigator exclude-from-print">
          <a
            [ngClass]="{ disabled: this.prevItem === undefined }"
            (click)="prev()">

            <i class="material-icons"> keyboard_arrow_left </i> vo­rheri­ges
            Dokument
          </a>
          <a
            [ngClass]="{ disabled: this.nextItem === undefined }"
            (click)="next()">
            nächstes Dokument <i class="material-icons"> keyboard_arrow_right
            </i>
          </a>
        </div>

        <div class="container">

          <!-- // check if document exists -->
          <div class="row pb-1 mb-4">
            <div class="col fixed-col d-flex justified-content-center
            align-items-center exclude-from-print">
              <ng-container *ngIf="document && document['_source']">
                <span *ngIf="document['_source']['docTyp']['id'] == '2'">
                  <span class="icon-box material-icons position-icon">
                    person
                  </span>
                </span>

                <span *ngIf="document['_source']['docTyp']['id'] == '3'">
                  <!-- Personen -->
                  <span class="icon-box material-icons position-icon">
                    location_city
                  </span>
                </span>

                <span *ngIf="document['_source']['docTyp']['id'] == '4'">
                  <!-- Protokolle -->
                  <span class="icon-box material-icons position-icon">
                    image
                  </span>
                </span>

                <span *ngIf="document['_source']['docTyp']['id'] == '5'">
                  <!-- Protokolle -->
                  <span class="icon-box material-icons position-icon">
                    ballot
                  </span>
                </span>

              </ng-container>
            </div>

            <div
              class="col-md-8 d-flex justified-content-center align-items-center">
              <div id="header">

                <ng-container
                  *ngIf="this.doc && this.doc['docTyp']['id'] == '2'">
                  <ng-container *ngIf="this.doc && this.doc['2_pnamefamily']">
                    <span>{{this.doc['2_pnamefamily']}}</span>
                  </ng-container>
                  <ng-container
                    *ngIf="this.doc && this.doc['2_pnamefamily'] && this.doc['2_pnamefirst']">,
                  </ng-container>
                  <ng-container *ngIf="this.doc && this.doc['2_pnamefirst']">
                    <span>{{this.doc['2_pnamefirst']}}</span>
                  </ng-container>

                  <ng-container
                    *ngIf="this.doc && this.doc['2_pnamecomponent']">
                    <span> {{this.doc['2_pnamecomponent']}}</span>
                  </ng-container>

                  <ng-container *ngIf="this.doc && this.doc['2_ptitledesign']">
                    <span>, {{this.doc['2_ptitledesign'].content}}</span>
                  </ng-container>

                  <ng-container *ngIf="this.doc && this.doc['2_pnametype']">
                    <ng-container
                      *ngFor="let item of this.doc['2_pnametype']; let
                    isLast=last">
                      ({{item.content}})
                    </ng-container>
                  </ng-container>
                </ng-container>

                <ng-container
                  *ngIf="this.doc && this.doc['docTyp']['id'] == '3'">
                  <ng-container *ngIf="this.doc && this.doc['3_stadt']">
                    {{ this.doc['3_stadt'].content}}
                  </ng-container>
                </ng-container>

                <ng-container
                  *ngIf="this.doc && this.doc['docTyp']['id'] == '4'">
                  <ng-container *ngIf="this.doc['4_obj_titel0']">
                    {{this.doc['4_obj_titel0']}}
                  </ng-container>
                </ng-container>

                <ng-container
                  *ngIf="this.doc && this.doc['docTyp']['id'] == '5'">
                  <ng-container *ngIf="this.doc && this.doc['5_erg4stadt']">
                    {{ this.doc['5_erg4stadt'].content}}
                  </ng-container>

                  <ng-container *ngIf="this.doc && this.doc['5_erg4wahl']">
                    <span> &#8211; </span>{{ this.doc['5_erg4wahl'].content}}
                  </ng-container>
                </ng-container>

              </div>
            </div>
            <div class="col"></div>
          </div>
        </div>
      </div>

      <div class="container-fluid document-content">
        <div class="documentSidenav no-print">

          <ng-container *ngIf="this.doc">

            <button (click)="addToMerkliste(document)" class="mb-2"
               color="primary" mat-mini-fab aria-label="Example
          icon button with a filter list icon">
              <ng-container *ngIf="boolean == false">
                <mat-icon matTooltip="Zur
                Merkliste hinzufügen">add</mat-icon>
              </ng-container>
              <ng-container *ngIf="boolean == true">
                <mat-icon matTooltip="Von der
                Merkliste entfernen">remove</mat-icon>
              </ng-container>
            </button>

            <!-- <button (click)="printDoc()" class="mb-2"
            
              matTooltip="Ansicht Drucken"
              color="primary" mat-mini-fab
              aria-label="Example icon button with a
          filter list icon">
              <mat-icon>print</mat-icon>
            </button> -->

            <button (click)="openDialog()" class="mb-2"
              matTooltip="Zitierrichtlinie kopieren" color="primary"
              mat-mini-fab>
              <mat-icon>announcement</mat-icon>
            </button>

            <button (click)="mailTo()"
              matTooltip="Kontakt" color="primary"
              mat-mini-fab>
              <mat-icon>chat</mat-icon>
            </button>

          </ng-container>

        </div>

        <div class="container">
          <!-- // metaInformation -->
          <mat-cart>

            <ng-container *ngIf="this.doc && this.doc['docTyp']['id'] == '2'">

              <ng-container
                *ngIf="this.doc && (this.doc['2_Ereignisse'] || this.doc['2_pgender'] || this.doc['2_personberuf'] || this.doc['2_html'])">
                <h2 class="mt-5">Biographisches</h2>
                <mat-card>
                  <div class="container">


                    <div class="row">
                      <!-- Meta information container -->
                      <div [ngClass]="this.doc['2_bannerfoto'] ? 'col-md-8' : 'col-md-12'">
                        <!-- Meta information content here -->

                        <ng-container *ngIf="this.doc && this.doc['2_Ereignisse']">
                          <div class="row zeile">
                            <div class="fixed-col">
                              <strong>Lebensdaten</strong>
                            </div>
                            <div class="col">
                              <ng-container
                                *ngFor="let event of this.doc['2_Ereignisse'] | keyvalue: asIsOrder; let first = first; let last = last">
                                <div class="row">
                                  <div class="fixed-col">{{
                                    event.value.peventsub[0].content }}</div>
                                  <div class="col ml-3">
                                    <span *ngIf="event.value.pstdatesub">{{
                                      getFormattedDate(event.value.pstdatesub) }}
                                    </span>

                                    <span *ngIf="event.value.pstdatesub && event.value.penddatesub">
                                      -
                                    </span>
    
                                    <span *ngIf="event.value.penddatesub">{{
                                      getFormattedDate(event.value.penddatesub)}}
                                    </span>

                                   
    
                                    <span *ngIf="event.value.pendverificationsub">{{
                                      event.value.pendverificationsub[0].content
                                      }}</span>
                                    <span *ngIf="event.value.psubjectsub"> ({{
                                      event.value.psubjectsub}})</span>
    
                                  </div>
                                </div>
                                <mat-divider *ngIf="!last"
                                  class="my-2"></mat-divider>
                              </ng-container>
                            </div>
                          </div>
                        </ng-container>
    
                        <ng-container *ngIf="this.doc && this.doc['2_pgender']">
                          <div class="row zeile">
                            <div class="fixed-col">
                              <strong>Geschlecht</strong>
                            </div>
                            <div class="col">
                              {{this.doc['2_pgender'].content}}
                            </div>
                          </div>
                        </ng-container>
    
                        <ng-container *ngIf="this.doc && this.doc['2_personberuf']">
                          <div class="row zeile">
                            <div class="fixed-col">
                              <strong>Genannter Beruf</strong>
                            </div>
                            <div class="col">
                              <ng-container
                                *ngFor="let beruf of this.doc['2_personberuf'];
                                let isLast=last">
                                {{beruf.content}}{{isLast? '' : ';'}}
                              </ng-container>
                            </div>
                          </div>
                        </ng-container>
    
                        <ng-container *ngIf="this.doc && this.doc['2_Namen']">
                          <div class="row zeile">
                            <div class="fixed-col">
                              <strong>Namensvarianten</strong>
                            </div>
                            <div class="col">
                              <ul
                                *ngFor="let item of this.doc['2_Namen']; let isLast=last">
                                <ng-container *ngIf="item.pnametypesub">
    
                                  <ng-container
                                    *ngFor="let item2 of item.wahlstadt; let isLast=last">
                                    <a (click)="item2.LmAdd.stadtdok"
                                      href="{{environment.wordpressPageUrl}}/#/document/{{item2.LmAdd.stadtdok}}"
                                      target="_self">{{item2.content}}</a>
                                  </ng-container>
    
                                </ng-container>
    
                                <ng-container *ngIf="item.pnamefirstsub">
                                  {{item.pnamefirstsub}}<span> </span>
                                </ng-container>
    
                                <ng-container *ngIf="item.pnamefamilysub">
                                  {{item.pnamefamilysub}}<span> </span>
                                </ng-container>
    
                                <ng-container *ngIf="item.pnamecomponentsub">
                                  {{item.pnamecomponentsub}}<span> </span>
                                </ng-container>
    
                                <ng-container *ngIf="item.ptitledesignsub">
                                  <ng-container
                                    *ngFor="let item2 of item.ptitledesignsub;
                                    let isLast=last">
                                    {{item2.content}}
                                  </ng-container>
                                </ng-container>
    
                                <ng-container
                                  *ngIf="item.pusedfromsub || item.pusedtosub">
                                  (
                                  <ng-container *ngIf="item.pusedfromsub">
                                    {{getFormattedDate(item.pusedfromsub)}}
                                  </ng-container>
                                  <ng-container *ngIf="item.pusedtosub">
                                    &mdash;{{getFormattedDate(item.pusedtosub)}}
                                  </ng-container>
                                  )
                                </ng-container>
                                <br />
                                <ng-container *ngIf="item.pnsourceref">
                                  <ng-container
                                    *ngFor="let item2 of item.pnsourceref; last
                                      as islast">
                                    {{item2.content}}<ng-container *ngIf="!last">;
                                    </ng-container>
                                  </ng-container>
                                </ng-container>
    
                                <ng-container *ngIf="item.pnotessub">
                                  {{item.pnotessub}}
                                </ng-container>
    
                                <!-- <ng-container *ngIf="!last">;</ng-container> -->
                              </ul>
                            </div>
                          </div>
                        </ng-container>

                        <ng-container *ngIf="this.doc && this.doc['2_html']">
                          <div class="row zeile">
                            <div class="fixed-col">
                              <strong>Biogramm</strong>
                            </div>
                            <div class="col">
                              <div innerHTML="{{this.doc['2_html']}}"></div>
                            </div>
                          </div>
                        </ng-container>
                      </div>
                      
                      <!-- Image container, only displayed if this.doc['2_bild'] exists -->
                      <ng-container *ngIf="this.doc['2_bannerfoto']">
                        <div class="col-md-4">

                       
                          <!-- Assuming this.doc['2_bild'] is the image URL or path -->
                          <a href="{{environment.wordpressPageUrl}}/#/document/{{this.image.id}}" (click)="toDocument(this.image.id)">
                          <img src="{{environment.wordpressThemeUrl}}/assets/vmimg/{{ this.image.datatitle }}" alt="Image Description" style="width: 100%;">
                          {{this.image.beschriftung}}
                         </a>
                        </div>
                      </ng-container>
                    </div>
                    

                 




                    



                  </div>



                </mat-card>
              </ng-container>

              <ng-container
                *ngIf="this.doc && (this.doc['2_Aemter'] || this.doc['2_parteizugehoerigkeit'] || this.doc['2_Allgemein'])">

                <h2 class="mt-5">Ratsfunktion</h2>
                <mat-card>
                  <div class="container">
                    <ng-container
                      *ngIf="this.doc && this.doc['2_parteizugehoerigkeit']">
                      <div class="row zeile">
                        <div class="fixed-col">
                          <strong>Parteizugehörigkeit</strong>
                        </div>
                        <div class="col">
                          <ng-container *ngFor="let item of
                  this.doc['2_parteizugehoerigkeit']; ; let isLast=last">
                            {{item.content}}{{isLast? '' : ';'}}
                          </ng-container>
                        </div>
                      </div>
                    </ng-container>

                    <ng-container *ngIf="this.doc && this.doc['2_Allgemein']">
                      <div class="row zeile">
                        <div class="fixed-col">
                          <strong>Ratsmandate</strong>
                        </div>
                        <div class="col">
                          <ul
                            *ngFor="let item of this.doc['2_Allgemein']; last as
                  islast">

                            <ng-container *ngIf="item.wahlstadt">
                              <div class="row">
                                <div class="fixed-col">
                                  Stadt
                                </div>
                                <div class="col">

                                  <ng-container
                                    *ngFor="let item2 of item.wahlstadt; last
                          as islast">
                                    <a
                                      (click)="toDocument(item2.LmAdd.stadtdok)"
                                      href="{{environment.wordpressPageUrl}}/#/document/{{item2.LmAdd.stadtdok}}"
                                      target="_self">{{item2.content}}</a>
                                  </ng-container>

                                </div>
                              </div>
                            </ng-container>

                            <ng-container *ngIf="item.legislatur">
                              <div class="row">
                                <div class="fixed-col">
                                  Wahl
                                </div>
                                <div class="col">

                                  <ng-container
                                    *ngFor="let item2 of item.legislatur; last
                          as islast">
                                    <a (click)="toDocument(item.wahl)"
                                      href="{{environment.wordpressPageUrl}}/#/document/{{item.wahl}}"
                                      target="_self">{{item2.content}}

                                      ({{getFormattedDate(item2.LmAdd.electiondate)}})
                                    </a>
                                  </ng-container>

                                </div>
                              </div>
                            </ng-container>

                            <ng-container *ngIf="item.wahlpartei">
                              <div class="row">
                                <div class="fixed-col">
                                  Partei

                                </div>
                                <div class="col">
                                  <ng-container
                                    *ngFor="let item2 of item.wahlpartei; last
                          as islast">
                                    {{item2.content}}
                                  </ng-container>

                                </div>
                              </div>
                            </ng-container>

                            <ng-container *ngIf="item.neuesmitgliedseit">
                              <div class="row">
                                <div class="fixed-col">
                                  nachgerückt am
                                </div>
                                <div class="col">
                                  {{getFormattedDate(item.neuesmitgliedseit)}}
                                </div>
                              </div>
                            </ng-container>

                            <ng-container *ngIf="item.nachgeruecktfuer">
                              <div class="row">
                                <div class="fixed-col">
                                  Nachgerückt für
                                </div>
                                <div class="col">

                                  <ng-container *ngFor="let item2 of
                          item.nachgeruecktfuer; let isLast=last">
                                    <a (click)="toDocument(item2.LmAdd.persdok)"
                                      href="{{environment.wordpressPageUrl}}/#/document/{{item2.LmAdd.persdok}}"
                                      target="_self">{{item2.content}}</a>
                                  </ng-container>

                                </div>
                              </div>
                            </ng-container>

                            <ng-container *ngIf="item.mitgliedbis">
                              <div class="row">
                                <div class="fixed-col">
                                  ausgeschieden am
                                </div>
                                <div class="col">
                                  {{getFormattedDate(item.mitgliedbis)}}
                                </div>
                              </div>
                            </ng-container>

                            <!-- <ng-container *ngIf="item.wahlbem">
                              <div class="row">
                                <div class="fixed-col">
                                  Bemerkung
                                </div>
                                <div class="col">
                                  {{item.wahlbem}}
                                </div>
                              </div>
                            </ng-container> -->

                            <!-- <ng-container *ngIf="!last">;</ng-container> -->
                          </ul>
                        </div>
                      </div>
                    </ng-container>

                    <ng-container *ngIf="this.doc && this.doc['2_Aemter']">
                      <div class="row zeile">
                        <div class="fixed-col">
                          <strong>Höhere Ämter</strong>
                        </div>
                        <div class="col">
                          <ul
                            *ngFor="let item of this.doc['2_Aemter']; let isLast=last">

                            <ng-container *ngIf="item.amt4stadt">

                              <ng-container
                                *ngFor="let item2 of item.amt4stadt; last
                      as islast">
                                <a (click)="item.linkstadt"
                                  href="{{environment.wordpressPageUrl}}/#/document/{{item.linkstadt}}"
                                  target="_self">{{item2.content}}</a>
                              </ng-container>

                            </ng-container>

                            <div class="row">

                              <div class="col-12">
                                <ng-container *ngIf="item.bmamtsbez">
                                  <ng-container
                                    *ngFor="let item2 of item.bmamtsbez;
                          let isLast=last">
                                    {{item2.content}}
                                  </ng-container>
                                </ng-container>

                                <ng-container *ngIf="item.bmdatumvon">
                                  <span>{{getFormattedDate(item.bmdatumvon)}}
                                  </span>
                                  <ng-container *ngIf="item.bmdateverif1">
                                    <ng-container
                                      *ngFor="let veri of item.bmdateverif1; let isLast=last">
                                      <span>(</span>{{veri.content}}{{isLast? ''
                                      : ';'}}<span>)</span>
                                    </ng-container>
                                  </ng-container>

                                  <ng-container *ngIf="item.bmdatumbis">
                                    <span> &#x2013;
                                    </span><span>{{getFormattedDate(item.bmdatumbis)}}
                                    </span> </ng-container>
                                </ng-container>

                                <ng-container *ngIf="item.bmdateverif">
                                  <ng-container
                                    *ngFor="let ver of item.bmdateverif;
                          let isLast=last">
                                    <span>(</span>{{ver.content}}<span>)</span>
                                    <ng-container *ngIf="!last">;
                                    </ng-container>
                                  </ng-container>
                                </ng-container>

                                <ng-container *ngIf="item.bmwahldatum">
                                  <span>, gewählt am: </span>
                                  {{getFormattedDate(item.bmwahldatum)}}
                                </ng-container>

                                <ng-container *ngIf="item.bmpartei">
                                  <span *ngIf="item.bmwahldatum">, </span>
                                  <ng-container
                                    *ngFor="let partei of item.bmpartei;
                          let isLast=last">
                                    {{partei.content}}{{isLast? '. ' : ''}}
                                  </ng-container>
                                </ng-container>

                              </div>
                            </div>

                            <!-- <ng-container *ngIf="item.bmbem">
                              <div class="row">
                                <div class="col-12">
                                  <span>[</span>{{item.bmbem}}<span>]</span>
                                </div>
                              </div>
                            </ng-container> -->
                            <!-- <ng-container *ngIf="!last">;</ng-container> -->
                          </ul>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </mat-card>

              </ng-container>

              <ng-container
                *ngIf="this.doc && (this.doc['2_gndlink'] || this.doc['2_rppdlink'])">

                <h2 class="mt-5">Externe Nachweise</h2>
                <mat-card>
                  <div class="container">
                    <ng-container *ngIf="this.doc && this.doc['2_gndlink']">
                      <div class="row zeile">
                        <div class="fixed-col">
                          <strong>GND</strong>
                        </div>
                        <div class="col">
                          <a href="{{this.doc['2_gndlink']}}"
                            target="_blank">{{this.doc['2_gndlink']}}</a>
                        </div>
                      </div>
                    </ng-container>

                    <ng-container *ngIf="this.doc && this.doc['2_rppdlink']">
                      <div class="row zeile">
                        <div class="fixed-col">
                          <strong>RPPD</strong>
                        </div>
                        <div class="col">

                          <a href="{{this.doc['2_rppdlink']}}"
                            target="_blank">{{this.doc['2_rppdlink']}}</a>
                        </div>
                      </div>
                    </ng-container>

                    <ng-container
                      *ngIf="this.doc && this.doc['2_literaturperson']">
                      <div class="row zeile">

                        <div class="col">
                          <div
                            innerHTML="{{this.doc['2_literaturperson']}}"></div>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </mat-card>

              </ng-container>

              <ng-container *ngIf="this.doc && this.doc['2_quellenperson']">
                <div class="row zeile">
                  <div class="fixed-col">
                    <strong>Quellen</strong>
                  </div>
                  <div class="col">
                    <div innerHTML="{{this.doc['2_quellenperson']}}"></div>
                  </div>
                </div>
              </ng-container>

            </ng-container>

            <ng-container *ngIf="this.doc && this.doc['docTyp']['id'] == '3'">

              <div class="row  mt-4">

                <ng-container *ngIf="this.doc && this.doc['3_html']">

                  <div class="col-md-6">

                    <div [innerHTML]="this.doc['3_html']"></div>

                  </div>

                </ng-container>

                <ng-container
                  *ngIf="this.doc && this.doc['3_bannerfoto'] && this.image">

                  <div class="col-md-6">

                    <ng-container *ngIf="this.image.datatitle">
                      <a (click)="toDocument(this.doc['3_bannerfoto'])"
                        href="{{environment.wordpressPageUrl}}#/document/{{this.doc['3_bannerfoto']}}"
                        target="_blank">

                        <div class="fillImage">
                          <img
                            src="{{environment.wordpressThemeUrl}}/assets/vmimg/{{this.image.datatitle}}">
                        </div>
                      </a>
                    </ng-container>

                    <ng-container *ngIf="this.image.beschriftung">
                      <div>{{this.image.beschriftung}}</div>
                    </ng-container>

                  </div>

                </ng-container>

                <div class="col-md-12">
                  <br>
                  <mat-accordion>
                    <mat-expansion-panel>
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          Literatur
                        </mat-panel-title>

                      </mat-expansion-panel-header>
                      <div class="px-4">
                        <ng-container
                          *ngIf="this.doc && this.doc['3_redkomm_stadtaemter']">
                          <div class="row zeile">
                            <div class="col-10">
                              <strong>red. Kommentar</strong>
                            </div>
                            <div class="col-10">
                              <div
                                innerHTML="{{this.doc['3_redkomm_stadtaemter']}}"></div>
                            </div>
                          </div>
                        </ng-container>

                        <ng-container
                          *ngIf="this.doc && this.doc['3_quellengrundlage']">
                          <div class="row zeile">
                            <div class="col-12 ">
                              <div class="list-style"
                                innerHTML="{{this.doc['3_quellengrundlage']}}"></div>
                            </div>
                          </div>
                        </ng-container>
                      </div>

                    </mat-expansion-panel>

                  </mat-accordion>
                </div>

              </div>

              <mat-tab-group mat-stretch-tabs
                class="mat-elevation-z4 w-100 mt-5 mb-5">
                <mat-tab label="Wahlen">

                  <div class="p-5">
                    <ng-container *ngIf="this.doc && this.StadtVerlinkung">
                      <div class="row ">

                        <div class="col-12">

                          <div class="timeline"
                            *ngFor="let doc5 of this.StadtVerlinkung.doc5">
                            <div class="timeline-item"
                              *ngIf="doc5 && doc5['_source'] && doc5['_source']['5_erg4wahl']">
                              <div class="event-date">
                                <a (click)="toDocument(doc5['_id'])"
                                  href="{{environment.wordpressPageUrl}}/#/document/{{doc5['_id']}}"
                                  target="_self">

                                  {{doc5['_source']['5_erg4wahl'].content}}<br>
                                  <ng-container
                                    *ngIf="doc5['_source']['5_erg4wahl'].LmAdd.electiondate">
                                    ({{getFormattedDate(doc5['_source']['5_erg4wahl'].LmAdd.electiondate)}})
                                  </ng-container>
                                </a>
                              </div>
                              <div class="timeline-point"></div>
                              <div class="event-content">
                                <div
                                  *ngIf="doc5 && doc5['_source'] && doc5['_source']['5_html']">
                                  <strong>Wahlergebnis</strong>
                                  <div
                                    [innerHTML]="doc5['_source']['5_html']"></div>
                                  <br>
                                </div>
                                <div *ngIf="doc5 && doc5.persons">
                                  <strong>Stadträte</strong>
                                  <div [innerHTML]="doc5.persons"></div>
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </ng-container>
                  </div>

                </mat-tab>

                <mat-tab label="Ämter" id="#aemter">

                  <div class="px-5">
                    <ng-container *ngIf="this.doc && this.aemter">
                      <div class="row zeile">

                        <div class="col-12">
                          <h2 class="blue">Ämter</h2>

                     

                            <ng-container *ngFor="let item2 of this.aemter3">
                              <li style="list-style: disc; margin-bottom: 0;">

                                <!-- {{item2.bmsortierung}} -->
                                  <ng-container *ngIf="item2.bmdatumvon">
                                    <span>{{getFormattedDate(item2.bmdatumvon)}}</span>
                                  </ng-container>

                                  <ng-container *ngIf="item2.bmdateverif1">
                                    <span>({{item2.bmdateverif1[0].content}})</span>
                                  </ng-container>

                                  <ng-container *ngIf="item2.bmdatumbis">
                                    <span> &#x2013;
                                    </span><span>{{getFormattedDate(item2.bmdatumbis)}}, </span>
                                  </ng-container>

                                  <ng-container *ngIf="item2.bmdateverif">

                                    <span>({{item2.bmdateverif[0].content}}), </span>
                                  </ng-container>

                                  <ng-container *ngIf="item2.bmamtsbez">
                                    <ng-container
                                      *ngFor="let item3 of item2.bmamtsbez">
                                      {{item3.content}}:
                                    </ng-container>
                                  </ng-container>



                                  <ng-container
                                  *ngIf="item2.content">
                                  <a (click)="toDocument(item2['ID'])"
                                    href="{{environment.wordpressPageUrl}}/#/document/{{item2['ID']}}">{{item2.content}}</a>
                                </ng-container>

                                  <ng-container *ngIf="item2.bmpartei">
                                    <span>, <ng-container
                                      *ngFor="let item3 of item2.bmpartei;
                                    let isLast=last">
                                      {{item3.content}}{{isLast? '' : '; '}}
                                    </ng-container>
                                  </span>
                                  </ng-container>
                              
                                </li>
                             
                            </ng-container>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </mat-tab>

              </mat-tab-group>

              <ng-container *ngIf="this.doc && this.doc['3_quellenneu']">
                <div class="row zeile mb-5">
                  <div class="col-12">
                    <strong>Quellen</strong>
                  </div>
                  <div class="col-12">
                    <div innerHTML="{{this.doc['3_quellenneu']}}"></div>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="this.doc && this.doc['3_bearbeitervermerk']">
                <div class="row zeile">
                  <div class="fixed-col">
                    <strong>Bearbeitervermerk</strong>
                  </div>
                  <div class="col">
                    {{this.doc['3_bearbeitervermerk']}}
                  </div>
                </div>
              </ng-container>

            </ng-container>

            <ng-container *ngIf="this.doc && this.doc['docTyp']['id'] == '4'">

              <ng-container *ngIf="this.doc['4_sourcename0']">
                <div class="docopenseadragon" [id]="'docopenseadragon'"> </div>

              </ng-container>

              <ng-container *ngIf="this.doc && this.doc['4_tf_beschriftung']">
                <div class="row zeile">
                  <div class="fixed-col">
                    <strong>Bildunterschrift</strong>
                  </div>
                  <div class="col">
                    {{this.doc['4_tf_beschriftung']}}
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="this.doc && this.doc['4_tf_urheber']">
                <div class="row zeile">
                  <div class="fixed-col">
                    <strong>Urheber/Fotograf</strong>
                  </div>
                  <div class="col">
                    <ng-container *ngFor="let urheber of
                      this.doc['4_tf_urheber']; let isLast=last">
                      {{urheber.content}}{{isLast? '' : '; '}}
                    </ng-container>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="this.doc && this.doc['4_motivkategorie']">
                <div class="row zeile">
                  <div class="fixed-col">
                    <strong>Motivkategorie</strong>
                  </div>
                  <div class="col">
                    {{this.doc['4_motivkategorie'].content}}
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="this.doc && this.doc['4_bildlink']">
                <div class="row zeile">
                  <div class="fixed-col">
                    <strong>Link zum Bild</strong>
                  </div>
                  <div class="col">
                    <a (click)="toDocument(this.doc['4_bildlink'])"
                      href="{{environment.wordpressPageUrl}}/#/document/{{this.doc['4_bildlink']}}">{{this.doc['4_bildlink']}}</a>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf=" this.doc && this.doc['4_tf_ort']">
                <div class="row zeile">
                  <div class="fixed-col">
                    <strong>Aufnahmeort</strong>
                  </div>
                  <div class="col">
                    {{this.doc['4_tf_ort'].content}}
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="this.doc && this.doc['4_linkstadt']">
                <div class="row zeile">
                  <div class="fixed-col">
                    <strong>Link zum Stadtdokument</strong>
                  </div>
                  <div class="col">
                    <a (click)="toDocument(this.doc['4_linkstadt'])"
                      href="{{environment.wordpressPageUrl}}/#/document/{{this.doc['4_linkstadt']}}"
                      target="_self">{{this.difDocStadt}}</a>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="this.doc && this.doc['4_tf_aufnahmedatum']">
                <div class="row zeile">
                  <div class="fixed-col">
                    <strong>Aufnahmedatum</strong>
                  </div>
                  <div class="col">
                    {{getFormattedDate(this.doc['4_tf_aufnahmedatum'] )}}

                    <ng-container *ngIf="this.doc['4_tf_dateverification']">
                      ({{this.doc['4_tf_dateverification'].content}})
                    </ng-container>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="this.doc && this.doc['4_pictureowner']">
                <div class="row zeile">
                  <div class="fixed-col">
                    <strong>Rechteinhaber</strong>
                  </div>
                  <div class="col">
                    <ng-container
                      *ngFor="let item of this.doc['4_pictureowner']; let isLast=last">
                      {{item.content}}{{isLast? '' : '; '}}
                    </ng-container>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="this.doc && this.doc['4_bildlizenz']">
                <div class="row zeile">
                  <div class="fixed-col">
                    <strong>Lizenzen</strong>
                  </div>
                  <div class="col">
                    {{this.doc['4_bildlizenz'].content}}
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="this.doc && this.doc['4_bildkeywords']">
                <div class="row zeile">
                  <div class="fixed-col">
                    <strong>Sachindex</strong>
                  </div>
                  <div class="col">
                    <ng-container *ngFor="let item of
                      this.doc['4_bildkeywords']; let isLast=last">
                      {{item.content}}{{isLast? '' : '; '}}
                    </ng-container>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="this.doc && this.doc['4_Bilddaten']">
                <div class="row zeile">
                  <div class="fixed-col">
                    <strong>Verzeichnete Personen</strong>
                  </div>
                  <div class="col">
                    <ng-container *ngFor="let item of this.doc['4_Bilddaten'];
                      let isLast=last">
                      <ng-container *ngIf="item.bildpersonen">

                        <ng-container *ngFor="let item2 of item.bildpersonen">
                          <ng-container *ngIf="item2.LmAdd.persdok">
                            <a (click)="toDocument(item2.LmAdd.persdok)"
                              href="{{environment.wordpressPageUrl}}/#/document/{{item2.LmAdd.persdok}}"
                              target="_self">
                              <ng-container
                                *ngIf="item2.content">{{item2.content}}</ng-container>
                            </a>
                          </ng-container>
                          <ng-container *ngIf="!item2.LmAdd.persdok">
                            <ng-container
                              *ngIf="item2.content">{{item2.content}}</ng-container>
                          </ng-container>

                        </ng-container>
                      </ng-container>

                      <ng-container *ngIf="item.tf_anmerkungen">
                        Anmerkungen: {{item.tf_anmerkungen}}
                      </ng-container>{{isLast? '' : '; '}}

                    </ng-container>
                  </div>
                </div>
              </ng-container>

              <!-- <ng-container *ngIf="this.doc && this.verknuepfungen">
                <div class="row zeile">
                  <div class="fixed-col">
                    <strong>Verknüpfungen</strong>
                  </div>
                  <div class="col">
                    <ng-container *ngFor="let item of this.verknuepfungen.doc3">
                      <ng-container *ngIf="item">
                        <a
                          href="{{environment.wordpressPageUrl}}/#/document/{{item['_id']}}">{{item['_source']['3_stadt'].content}}</a>
                      </ng-container>

                    </ng-container>
                  </div>
                </div>
              </ng-container> -->

              <ng-container *ngIf="this.doc && this.doc['4_bildbem']">
                <div class="row zeile">
                  <div class="fixed-col">
                    <strong>Anmerkung</strong>
                  </div>
                  <div class="col">
                    {{this.doc['4_bildbem']}}

                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="this.doc && this.doc['4_html']">
                <div class="row zeile">
                  <div class="fixed-col">
                    <strong>Beschreibung</strong>
                  </div>
                  <div class="col">
                    <div innerHTML="{{this.doc['4_html']}}"></div>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="this.doc && this.doc['4_Nachweis']">
                <div class="row zeile">
                  <div class="fixed-col">
                    <strong>Nachweis</strong>
                  </div>
                  <div class="col">
                    <ng-container *ngFor="let item of this.doc['4_Nachweis']">
                      <!-- <ng-container *ngIf="item.tf_nachweistyp">
                        Nachweistyp
                        <ng-container *ngFor="let item2 of item.tf_nachweistyp">
                          {{item2.content}}
                        </ng-container>
                        <br>
                      </ng-container> -->

                      <ng-container *ngIf="item.tf_aufbewahrungsort">
                        Aufbewahrungsort:
                        <ng-container *ngFor="let item2 of
                          item.tf_aufbewahrungsort">
                          {{item2.content}}
                        </ng-container>
                        <br>
                      </ng-container>

                      <ng-container *ngIf="item.tf_signaturinventarnummer">
                        <div class="col-md-3">Signatur/Inventarnummer</div>
                        <div
                          class="col-md-9">{{item.tf_signaturinventarnummer}}</div>
                      </ng-container>

                      <ng-container *ngIf="item.tf_link">
                        Link <a (click)="toDocument(item.tf_link)"
                          href="{{environment.wordpressPageUrl}}/#/document/{{item.tf_link}}">{{item.tf_link}}</a>
                        <ng-container *ngIf="item.nachweislinkdate">
                          <span>(abgerufen am:
                          </span>{{item.nachweislinkdate}}<span>)</span>
                        </ng-container>
                      </ng-container>

                    </ng-container>
                  </div>
                </div>
              </ng-container>

            </ng-container>

            <ng-container *ngIf="this.doc && this.doc['docTyp']['id'] == '5'">

              <ng-container *ngIf="this.doc && this.doc['5_erg4stadt']">
                <div class="row zeile">
                  <div class="fixed-col">
                    <strong>Stadt</strong>
                  </div>
                  <div class="col">
                    <a
                      (click)="toDocument(this.doc['5_erg4stadt'].LmAdd.stadtdok)"
                      href="{{environment.wordpressPageUrl}}/#/document/{{this.doc['5_erg4stadt'].LmAdd.stadtdok}} "
                      target="_self">{{this.doc['5_erg4stadt'].content}}</a>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="this.doc && this.doc['5_erg4wahl']">
                <div class="row zeile">
                  <div class="fixed-col">
                    <strong>Wahldatum</strong>
                  </div>
                  <div class="col">
                    {{this.doc['5_erg4wahl'].content}}
                    <ng-container
                      *ngIf="this.doc['5_erg4wahl'].LmAdd.electiondate">
                      ({{getFormattedDate(this.doc['5_erg4wahl'].LmAdd.electiondate)}})
                    </ng-container>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="this.doc && this.doc['5_html']">
                <div class="row zeile">
                  <div class="fixed-col">
                    <strong>Wahlergebnis</strong>
                  </div>
                  <div class="col">
                    <div innerHTML="{{this.doc['5_html']}}"></div>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="this.doc && this.doc['5_wahlreferenz']">
                <div class="row zeile">
                  <div class="fixed-col">
                    <strong>Quelle</strong>
                  </div>
                  <div class="col">
                    {{this.doc['5_wahlreferenz'].content}}
                    <ng-container *ngIf="this.doc['5_wahlreferenzseite']">
                      {{this.doc['5_wahlreferenzseite']}}
                    </ng-container>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="this.doc && this.doc['5_wahlberechtigte']">
                <div class="row zeile">
                  <div class="fixed-col">
                    <strong>Wahlberechtigte</strong>
                  </div>
                  <div class="col">
                    {{this.doc['5_wahlberechtigte']}}
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="this.doc && this.doc['5_anz_waehler']">
                <div class="row zeile">
                  <div class="fixed-col">
                    <strong>Wähler insgesamt</strong>
                  </div>
                  <div class="col">
                    {{this.doc['5_anz_waehler']}}
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="this.doc && this.doc['5_wahlbeteiligung']">
                <div class="row zeile">
                  <div class="fixed-col">
                    <strong>Wahlbeteiligung (in %)</strong>
                  </div>
                  <div class="col">
                    {{this.doc['5_wahlbeteiligung']}}
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="this.doc && this.doc['5_ungueltig']">
                <div class="row zeile">
                  <div class="fixed-col">
                    <strong>Ungültige Stimmen</strong>
                  </div>
                  <div class="col">
                    {{this.doc['5_ungueltig']}}
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="this.doc && this.doc['5_Ergebnis_Details']">
                <div class="row zeile">
                  <div class="fixed-col">
                    <strong>Stimmenanteile Parteien</strong>
                  </div>
                  <div class="col">
                    <ng-container *ngFor="let item of
                      this.doc['5_Ergebnis_Details']">

                      <ng-container *ngIf="item.ergpropartei">
                        <strong>Partei: </strong>{{item.ergpropartei.content}}
                      </ng-container>

                      <ng-container *ngIf="item.parteisitze">
                        <strong>Sitze: </strong>{{item.parteisitze}}
                      </ng-container>

                      <ng-container *ngIf="item.parteiergbem">
                        <strong>Bemerkung: </strong>{{item.parteiergbem}}
                      </ng-container>

                    </ng-container>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="this.doc && this.doc['5_ratsmitglieder']">
                <div class="row zeile">
                  <div class="fixed-col">
                    <strong>Ratsmitglieder (Anzahl)</strong>
                  </div>
                  <div class="col">
                    {{this.doc['5_ratsmitglieder']}}
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="this.persons && this.persons.length != 0">
                <div class="row zeile">
                  <div class="fixed-col">
                    <strong>Ratsmitglieder</strong>
                  </div>
                  <div class="col">
                    <ng-container
                      *ngFor="let item of this.persons; let isLast=last">
                      <a (click)="toDocument(item.link)"
                        href="{{environment.wordpressPageUrl}}/#/document/{{item.link}}"
                        target="_self">{{item.name}}<ng-container
                          *ngIf="item.partei !== ''">({{item.partei}})</ng-container>{{isLast?
                        '.' : '; '}}</a>
                      <!-- FEHLER MAPPING -->
                      <!-- <ng-container *ngFor="let item2 of item.partei; last as isLast">
                  <ng-container *ngFor="let item3 of item2.wahlpartei; last as isLast">
                    {{item3.content}}
                  </ng-container>
                </ng-container> -->

                    </ng-container>

                  </div>
                </div>
              </ng-container>

            </ng-container>

          </mat-cart>
        </div>

        <app-annotation *ngIf="document" [document]="document"></app-annotation>

      </div>

      <div class="container-fluid document-footer">
        <div class="container">
          <div class="row footer">
            <div class="col">

              <!-- <ng-container *ngIf="this.doc && this.doc['timecreate']">
              <div class="row zeile">
                <div class="fixed-col">
                  <strong>Erstellungsdatum</strong>
                </div>
                <div class="col">
                  {{this.doc['timecreate']}}
                </div>
              </div>
            </ng-container> -->

              <!-- <ng-container *ngIf="this.doc && this.doc['2_contributors']">
              <div class="row zeile">
                <div class="fixed-col">
                  <strong>Bearbeiter:innen</strong>
                </div>
                <div class="col">
                  <ng-container *ngFor="let item of
                    this.doc['2_contributors']; let isLast=last">
                    {{item.content}}{{isLast? '' : '; '}}
                  </ng-container>
  
                </div>
              </div>
            </ng-container> -->

              <ng-container *ngIf="this.doc && this.doc['timelastchg']">
                <div class="row zeile">
                  <div class="fixed-col">
                    <strong>letzte Bearbeitung</strong>
                  </div>
                  <div class="col">
                    {{getFormattedDate(this.doc['timelastchg'])}}
                  </div>
                </div>
              </ng-container>

            </div>
          </div>
        </div>
      </div>

    </ng-container>

  </div>

</div>

<!--container-fluid-->
